export const styles = {
  root: {
    py: 1.5,
    px: 2,
    textAlign: 'center',
  },
  text: {
    m: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: 'text.secondary',
  },
};
